import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import "./i18n"

import "@fontsource/roboto/300.css"
import "@fontsource/roboto/400.css"
import "@fontsource/roboto/500.css"
import "@fontsource/roboto/700.css"
import "./index.css"
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://505d994517f83275c55ed6757b6860a9@o1047151.ingest.us.sentry.io/4510311785037824",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

import App from "./App.tsx"

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
